import { render, staticRenderFns } from "./MonthAllowancesPlanAdd.vue?vue&type=template&id=29124424&scoped=true&"
import script from "./MonthAllowancesPlanAdd.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29124424",
  null
  
)

export default component.exports